import React, { PureComponent, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import isEmptyObject from '../utility/isEmptyObject'
import Button from '@material-ui/core/Button'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import format from 'date-fns/format'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  flex: {
    flex: '1 1 auto'
  },
  buttonRoot: {
    padding: '0px 5px',
    minHeight: '0px',
    minWidth: '24px'
  }
})

class SliderDatetime extends PureComponent {
  static defaultProps = {
    layerName: '',
    min: 0.1,
    max: 100,
    value: 100
  }

  render () {
    const {
      epochtimes,
      marks,
      epochtime,
      handleChange,
      classes,
      handlePrevious,
      handleNext,
      ageLimit,
      datetimeValue
    } = this.props

    if (!epochtimes || !marks || isEmptyObject(marks)) {
      return null
    }

    if (Object.keys(marks).length <= 1) {
      return null
    }

    const min = epochtimes[0]
    const max = epochtimes[epochtimes.length - 1]

    return (
      <Fragment>
        <div style={{ display: 'block', width: '100%' }} >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography key='title'>Date</Typography>
            <Typography key='value'>{datetimeValue}</Typography>
          </div>
          <div className={classes.container}>
            <Button
              onClick={handlePrevious}
              classes={{ root: classes.buttonRoot }}
              disableRipple
              disableFocusRipple
            >
              <ChevronLeftIcon />
            </Button>
            <Slider
              className={classes.flex}
              onChange={handleChange}
              value={epochtime}
              min={min}
              max={max}
              marks={marks}
              step={null}
              included={false}
            />
            <Button
              onClick={handleNext}
              classes={{ root: classes.buttonRoot }}
              disableRipple
              disableFocusRipple
            >
              <ChevronRightIcon />
            </Button>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withStyles(styles)(SliderDatetime)



// WEBPACK FOOTER //
// ./src/components/SliderDatetime.js